(function(){
    document.body.addEventListener('change', function (event) {
        if (event.target.closest('.form-cycle')) {
            var form = event.target.closest('.form-cycle');
            var url = form.getAttribute('data-url');
            var cycle_summary = form.querySelector('.cycle-summary');
            var permalink = form.querySelector('.cycle-copy-permalink');

            fetch(url, {
                method: 'post',
                body: new FormData(form)
            }).then(res=>res.json())
                .then(function (data) {
                    cycle_summary.innerHTML = data.summary;
                    permalink.setAttribute('href', data.permalink);

                    var tooltipTriggerList = cycle_summary.querySelectorAll('[data-bs-toggle="tooltip"]');
                    var tooltipList = Array.prototype.slice.call(tooltipTriggerList).map(function (tooltipTriggerEl) {
                        return new bootstrap.Tooltip(tooltipTriggerEl);
                    });
                });
        }
    });

    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.cycle-item-add-switcher') && event.target.closest('.btn')) {
            event.preventDefault();

            var switcher = event.target.closest('.cycle-item-add-switcher');
            var btn = event.target.closest('.btn');
            var btns = switcher.querySelectorAll('.btn');
            var value = btn.getAttribute('data-set-value');
            var input = switcher.querySelector('input');

            btns.forEach(function(_btn) {
                _btn.classList.remove('d-none');
            });

            btn.classList.add('d-none');

            input.value = value;

            input.dispatchEvent(new Event('change', {bubbles: true}));
        }
    });

    document.body.addEventListener('change', function(event) {
        if (event.target.closest('[data-toggle="course-quantity"]')) {
            var value = event.target.closest('[data-toggle="course-quantity"]').value;
            var form = event.target.closest('.form-cycle');

            console.log(value);

            form.querySelectorAll('[data-course-quantity]').forEach(function(item){
                item.classList.add('d-none');
            });

            form.querySelectorAll('[data-course-quantity="'+value+'"]').forEach(function(item){
                item.classList.remove('d-none');
            });
        }
    });

    document.body.addEventListener('click', function(event) {
        if (event.target.closest('[data-toggle="copy-url"]')) {
            var target = event.target.closest('[data-toggle="copy-url"]');

            event.preventDefault();

            console.log(target.getAttribute('href'));

            var parent = event.target.parentNode;

            var temp = document.createElement("input");
            document.body.appendChild(temp);
            temp.value = target.getAttribute('href');
            temp.select();
            document.execCommand("copy");
            document.body.removeChild(temp);

            target.querySelector('i').classList.add('icon-circle-check', 'text-success');
            target.querySelector('i').classList.remove('icon-copy', 'text-primary');
            setTimeout(function(){
                target.querySelector('i').classList.add('icon-copy', 'text-primary');
                target.querySelector('i').classList.remove('icon-circle-check', 'text-success');
            }, 1000);
        }
    });
})();